import React from "react";
import AuthInput from "../../Components/AuthInput";
import { Link } from "react-router-dom";
import useLogin from "./useLogin.js";
import OTPInput from "../../Components/OTPInput";
import AuthScreenLayout from "../../Components/Auth/AuthScreenLayout";
import AuthBrandMark from "../../Components/Auth/AuthBrandMark";
import {
  authPrimaryButtonClass as primaryBtn,
  authSecondaryButtonClass as secondaryBtn,
} from "../../Components/Auth/authClasses";

export default function Login() {
  const {
    register,
    handleSubmit,
    onSubmit,
    errors,
    showOtpForm,
    otp,
    setOtp,
    onOtpSubmit,
    otpError,
    otpSuccess,
    resendLoading,
    settings,
    onResendOtp,
    onSkip,
    signupEmail,
  } = useLogin({});

  return (
    <AuthScreenLayout cardMaxWidthClass="max-w-2xl">
      <AuthBrandMark settings={settings} />

      {showOtpForm ? (
        <form onSubmit={onOtpSubmit} className="space-y-6">
          <div className="text-center">
            <h1 className="text-xl font-semibold tracking-tight text-white sm:text-2xl">Verify OTP</h1>
            <p className="mt-2 text-sm leading-relaxed text-white/70">
              A verification code has been sent to{" "}
              <strong className="font-medium text-white">{signupEmail || "your email"}</strong>
            </p>
          </div>

          <OTPInput value={otp} onChange={setOtp} length={6} disabled={resendLoading} variant="glass" />

          {otpError ? <p className="text-center text-sm text-red-400">{otpError}</p> : null}
          {otpSuccess ? <p className="text-center text-sm text-emerald-400">{otpSuccess}</p> : null}

          <div className="space-y-3 pt-1">
            <button type="submit" className={primaryBtn} disabled={otp.length !== 6}>
              Verify OTP
            </button>
            <button type="button" className={secondaryBtn} onClick={onResendOtp} disabled={resendLoading}>
              {resendLoading ? "Resending…" : "Resend OTP"}
            </button>
            <button
              type="button"
              onClick={onSkip}
              className="w-full text-center text-sm text-white/65 transition hover:text-white"
            >
              Skip for now
            </button>
          </div>
        </form>
      ) : (
        <>
          <div className="mb-6 text-center sm:mb-8">
            {/* <p className="text-sm text-white/65">Professional Weather Intelligence Portal</p> */}
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <AuthInput
              label="Email"
              type="email"
              name="email"
              id="email"
              placeholder="Enter Your Email"
              errors={errors}
              register={register}
              variant="glass"
            />
            <AuthInput
              label="Password"
              type="password"
              name="password"
              id="password"
              placeholder="Enter Your Password"
              errors={errors}
              register={register}
              variant="glass"
            />
            <div className="pt-1">
              <button type="submit" className={primaryBtn}>
                Log In
              </button>
            </div>
            <div className="flex justify-end pt-1">
              <Link
                to="/forgot-password"
                className="text-sm text-white/80 transition hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue"
              >
                Forgot Password?
              </Link>
            </div>
          </form>

          <p className="mt-8 text-center text-sm text-white/75">
            Don&apos;t have an account?{" "}
            <Link
              to="/Signup"
              className="font-semibold text-white transition hover:text-white/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue"
            >
              Sign up
            </Link>
          </p>
        </>
      )}
    </AuthScreenLayout>
  );
}
